import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreAllSalesforceOrganizationsByCustomerGetSlice } from './get';

export const coreAllSalesforceOrganizationsReducers = combineReducers({
	get: coreAllSalesforceOrganizationsByCustomerGetSlice.asyncReducers
});

export const coreAllSalesforceOrganizationsWatchers = combineAllWatchers([
	coreAllSalesforceOrganizationsByCustomerGetSlice.asyncWatchers
]);
